export const activeOperations = [
  { name: "Data Science Services", path: "/operations/data-science-services-australia" },
  { name: "Angel Investor", path: "/operations/angel-investor" },
  { name: "Hospitality Operations", path: "/operations/hospitality" },
  { name: "Management Consulting", path: "/operations/management-consulting" },
  { name: "Software & Web Development", path: "/operations/software-web-development" },
];

export const activeProducts = [
  { name: "AMLyticsAI", path: "/products/amlyticsai" },
];

// Currently inactive/commented operations in Navbar:
// { name: "Mining Consulting", path: "/operations/mining-consulting" },
// { name: "Petroleum Consulting", path: "/operations/petroleum-consulting" },
// { name: "Virtual Manager", path: "/virtual-manager" }
